import { FilterGroup } from '../typings';
import type { AssetTypes, UxAsset } from './index';

export type AssetData = {
  origin_url?: string;
  price?: number | null;
  originalPrice?: number | null;
};

export default abstract class Asset<AssetDataType extends AssetData = AssetData> {
  // Original URL Asset was parsed from
  origin_url: string;
  price: number | null;
  originalPrice: number | null;

  /**
   * All available prices of an Asset. On sale prices, MSRP, etc.
   */
  abstract get prices(): number[];

  abstract filterCTA(filterGroups: FilterGroup[]): boolean;

  protected constructor(
    // Used to store the internal asset type
    public _type: keyof AssetTypes,
    data: AssetDataType
  ) {
    this.origin_url = data.origin_url || window.location.href;
    this.price = data.price !== undefined ? data.price : null;
    this.originalPrice = data.originalPrice !== undefined ? data.originalPrice : null;
  }

  /**
   * Checks the properties of two Asset Classes for Equality. Fields to check
   * are based on `this` Asset - if the `other` asset has additional properties,
   * it may still be considered equal.
   * @param other Asset Class to compare fields with
   */
  equals<T extends Asset>(other?: T): boolean {
    if (!other) return false;

    const props = Object.getOwnPropertyNames(this).filter((n) => !n.startsWith('_'));
    for (const prop of props) {
      // @ts-ignore [TS7053] Typescript is complaining about this[prop] and other[prop]
      //            being implicitly any, but that's okay
      if (this[prop] !== other[prop]) return false;
    }

    return true;
  }

  abstract toUxServer(): UxAsset;
}
